// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import "amfe-flexible";
import 'vant/lib/index.css';
import store from './store'; // 引入 Vuex store

import { Loading, Image as VanImage, Overlay, List, NavBar, Tabbar, PullRefresh, TabbarItem, Lazyload, Swipe, SwipeItem, Search, Field, Cell, CellGroup, Collapse, CollapseItem} from 'vant';

const app = createApp(App);
const components = [ store, Loading, VanImage, Overlay, List, NavBar, Tabbar, PullRefresh, TabbarItem, Swipe, SwipeItem, Search, Field, Cell, CellGroup, Collapse, CollapseItem];

components.forEach(component => {
    app.use(component);
});

app.use(Lazyload, {
    lazyComponent: true,
});
app.use(router).mount('#app');
